import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import InternalLayout from '../components/layouts/InternalLayout';
import { Login } from '../screens/login/Login';
import PrivateRoute from "./PrivateRoute";
import { Breadcrumb } from '../components/breadcrumb/Breadcrumb';
import { displayMessage } from '../helpers/messages';

// Screens - Users
import ListUsers from '../screens/user/ListUsers';
import DetailUser from '../screens/user/DetailUser';

// Screens - Clients
import ListClients from '../screens/client/ListClients';
import DetailClient from '../screens/client/DetailClient';

// Screens - Batches
import ListBatches from '../screens/batch/ListBatches';
import DetailBatch from '../screens/batch/DetailBatch';

// Screens - Dashboard
import Dashboard from '../screens/dashboard/Dashboard';

// Screens - Login
import { LoginForm } from '../screens/login/LoginForm';
import { ResetPasswordForm } from '../screens/login/ResetPasswordForm';
import ChangePassword from '../screens/login/ChangePassword';

// Screens - Profile
import DetailProfile from '../screens/user/DetailProfile';

const router = (
  <>
    <Route path='/' element={<PrivateRoute />}>
      <Route element={<InternalLayout />}>
        {/* Usuários */}
        <Route path='users'>
          <Route
            index
            element={
              <Breadcrumb
                listCrumbs={[{ label: displayMessage('USERS'), link: '/users' }]}>
                <ListUsers />
              </Breadcrumb>
            }
          />

          <Route
            path=':idUser'
            element={
              <Breadcrumb
                listCrumbs={[
                  { label: displayMessage('USERS'), link: '/users' },
                  { label: displayMessage('USER') + ': {idUser}', params: ['idUser'] }
                ]}>
                <DetailUser />
              </Breadcrumb>
            }
          />
        </Route>

        {/* Clientes */}
        <Route path='clients'>
          <Route
            index
            element={
              <Breadcrumb
                listCrumbs={[{ label: displayMessage('CLIENTS'), link: '/clients' }]}>
                <ListClients />
              </Breadcrumb>
            }
          />

          <Route
            path=':idClient'
            element={
              <Breadcrumb
                listCrumbs={[
                  { label: displayMessage('CLIENTS'), link: '/clients' },
                  { label: displayMessage('CLIENT') + ': {idClient}', params: ['idClient'] }
                ]}>
                <DetailClient />
              </Breadcrumb>
            }
          />
        </Route>

        {/* Dashboard */}
        <Route
          path="dashboard"
          element={
            <Breadcrumb
              listCrumbs={[{ label: 'Dashboard' }]}
            >
              <Dashboard />
            </Breadcrumb>
          }
        />

        {/* Lotes (Batches) */}
        <Route path='batches'>
          <Route
            index
            element={
              <Breadcrumb
                listCrumbs={[{ label: displayMessage('BATCHES'), link: '/batches' }]}>
                <ListBatches />
              </Breadcrumb>
            }
          />

          <Route
            path=':idBatch'
            element={
              <Breadcrumb
                listCrumbs={[
                  { label: displayMessage('BATCHES'), link: '/batches' },
                  { label: displayMessage('BATCH') + ': {idBatch}', params: ['idBatch'] }
                ]}>
                <DetailBatch />
              </Breadcrumb>
            }
          />
        </Route>

        {/* Perfil */}
        <Route
          path="profile"
          element={
            <Breadcrumb
              listCrumbs={[{ label: displayMessage('MY_PROFILE') }]}
            >
              <DetailProfile />
            </Breadcrumb>
          }
        />

        {/* Redirect raiz para lotes */}
        <Route
          index
          element={<Navigate to="/batches" replace />}
        />
      </Route>

      {/* Alterar senha */}
      <Route path="change-password" element={<ChangePassword />} />
    </Route>

    {/* Login */}
    <Route path="login" element={<Login />}>
      <Route index element={<LoginForm />} />
      <Route path="reset-password/:token" element={<ResetPasswordForm />} />
    </Route>
  </>
);

function Router() {
  return (
    <BrowserRouter>
      <Routes>
        {router}
      </Routes>
    </BrowserRouter>
  );
}

export default Router;



